<div #triggerElemRef (click)="onTriggerClick(triggerElemRef)" class="cursor-pointer">
  <ng-content></ng-content>
</div>

<button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" class="hidden-button"></button>

<mat-menu #menu="matMenu" [xPosition]="menuXPosition" [yPosition]="menuYPosition" [overlapTrigger]="false">
  <ng-template matMenuContent>
    <ng-container *ngIf="(store.workflowStepAssignmentsLoading | async) === ELoadStatus.success">
      <ng-container *ngIf="workflowStepOptions.length > 0; else noData">
        <ng-container *ngFor="let workFlowStep of workflowStepOptions">
          <button mat-menu-item (click)="selectMenuItem(workFlowStep)">
            <div class="d-flex align-items-center">
              <mat-icon *ngIf="workFlowStep.statusCategory === 'todo'" class="gray">adjust</mat-icon>
              <mat-icon *ngIf="workFlowStep.statusCategory === 'inProgress'" class="blue">schedule</mat-icon>
              <mat-icon *ngIf="workFlowStep.statusCategory === 'done'" class="green">task_alt</mat-icon>
              <span
                class="ms-1 fw-700 f-12"
                [ngClass]="
                  workFlowStep.statusCategory === EWorkflow.done
                    ? 'green'
                    : workFlowStep.statusCategory === EWorkflow.inProgress
                      ? 'blue'
                      : 'gray'
                "
              >
                {{ workFlowStep.name | uppercase }}</span
              >
            </div>
          </button>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <div class="no-data-item">{{ 'system.message.noStatusTransitionAvailable' | translate }}</div>
      </ng-template>
    </ng-container>
  </ng-template>
</mat-menu>
